import React from 'react'
import './Refer.scss';
import ReferImage from '../../../../assets/ReferImage.png';

export default function Refer() {
  return (
    <div className='refer-container'>
      <div className='left-section'>
        <h1>Refer & Earn</h1>
        <p>
          Share your unique referral code and get rewarded when your friends join. Every successful referral brings you bonus coins—help your friends while helping yourself! It’s a win-win for everyone.
        </p>
      </div>
      <div className='right-section'>
        <img src={ReferImage} alt="refer and earn coins" />
      </div>
    </div>
  )
}
